module.exports = __webpack_public_path__ + "media/img/axis/SS000-1912f45fd1571d04391d95ab8a7be993.png";